"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const BadgeStatus = (props) => {
    if (!props.visualStatus)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'align-items-center', style: { minWidth: 'max-content' }, children: [(0, jsx_runtime_1.jsx)("span", { className: `label label-${props.visualStatus.color} label-dot mr-2` }), (0, jsx_runtime_1.jsx)("span", { className: `font-weight-bold text-${props.visualStatus.color}`, children: props.visualStatus.name })] }));
};
exports.default = BadgeStatus;
